import * as React from "react";

// import "./otp.css";
import { Box, Button, styled } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LockResetIcon from "@mui/icons-material/LockReset";
import logo from "../../images/PPKM_Head.png";
import OTPicon from "../../images/otpIcon.png";
import { Input as BaseInput } from "@mui/base/Input";
import getEventController from "../Member/Controller/getEvent_controller";

const InputElement = styled("input")(
  ({ theme }) => `
  width: 40px;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 0px;
  text-align: center;
`
);

function OTPform({ separator, length, value, onChange }) {
  const inputRefs = React.useRef(new Array(length).fill(null));

  const focusInput = (targetIndex) => {
    const targetInput = inputRefs.current[targetIndex];
    targetInput.focus();
  };

  const selectInput = (targetIndex) => {
    const targetInput = inputRefs.current[targetIndex];
    targetInput.select();
  };

  const handleKeyDown = (event, currentIndex) => {
    switch (event.key) {
      case "ArrowUp":
      case "ArrowDown":
      case " ":
        event.preventDefault();
        break;
      case "ArrowLeft":
        event.preventDefault();
        if (currentIndex > 0) {
          focusInput(currentIndex - 1);
          selectInput(currentIndex - 1);
        }
        break;
      case "ArrowRight":
        event.preventDefault();
        if (currentIndex < length - 1) {
          focusInput(currentIndex + 1);
          selectInput(currentIndex + 1);
        }
        break;
      case "Delete":
        event.preventDefault();
        onChange((prevOtp) => {
          const otp =
            prevOtp.slice(0, currentIndex) + prevOtp.slice(currentIndex + 1);
          return otp;
        });

        break;
      case "Backspace":
        event.preventDefault();
        if (currentIndex > 0) {
          focusInput(currentIndex - 1);
          selectInput(currentIndex - 1);
        }

        onChange((prevOtp) => {
          const otp =
            prevOtp.slice(0, currentIndex) + prevOtp.slice(currentIndex + 1);
          return otp;
        });
        break;

      default:
        break;
    }
  };

  const handleChange = (event, currentIndex) => {
    const currentValue = event.target.value;
    let indexToEnter = 0;

    while (indexToEnter <= currentIndex) {
      if (
        inputRefs.current[indexToEnter].value &&
        indexToEnter < currentIndex
      ) {
        indexToEnter += 1;
      } else {
        break;
      }
    }
    onChange((prev) => {
      const otpArray = prev.split("");
      const lastValue = currentValue[currentValue.length - 1];
      otpArray[indexToEnter] = lastValue;
      return otpArray.join("");
    });
    if (currentValue !== "") {
      if (currentIndex < length - 1) {
        focusInput(currentIndex + 1);
      }
    }
  };

  const handleClick = (event, currentIndex) => {
    selectInput(currentIndex);
  };

  const handlePaste = (event, currentIndex) => {
    event.preventDefault();
    const clipboardData = event.clipboardData;

    // Check if there is text data in the clipboard
    if (clipboardData.types.includes("text/plain")) {
      let pastedText = clipboardData.getData("text/plain");
      pastedText = pastedText.substring(0, length).trim();
      let indexToEnter = 0;

      while (indexToEnter <= currentIndex) {
        if (
          inputRefs.current[indexToEnter].value &&
          indexToEnter < currentIndex
        ) {
          indexToEnter += 1;
        } else {
          break;
        }
      }

      const otpArray = value.split("");

      for (let i = indexToEnter; i < length; i += 1) {
        const lastValue = pastedText[i - indexToEnter] ?? " ";
        otpArray[i] = lastValue;
      }

      onChange(otpArray.join(""));
    }
  };

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
      {new Array(length).fill(null).map((_, index) => (
        <React.Fragment key={index}>
          <BaseInput
            slots={{
              input: InputElement,
            }}
            aria-label={`Digit ${index + 1} of OTP`}
            slotProps={{
              input: {
                ref: (ele) => {
                  inputRefs.current[index] = ele;
                },
                onKeyDown: (event) => handleKeyDown(event, index),
                onChange: (event) => handleChange(event, index),
                onClick: (event) => handleClick(event, index),
                onPaste: (event) => handlePaste(event, index),
                value: value[index] ?? "",
              },
            }}
          />
          {index === length - 1 ? null : separator}
        </React.Fragment>
      ))}
    </Box>
  );
}

const OTP = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = React.useState("");
  const [otp, setOtp] = React.useState("");
  const { email, userID, sent_otp } = location.state; // Access passed data
  const [sentOtp, setSentOtp] = React.useState(location.state?.sent_otp || "");
  console.log(email);
  console.log(userID);
  console.log(sentOtp);

  const handleSubmitOTP = async (e) => {
    e.preventDefault();

    console.log(otp);

    if (sentOtp == otp) {
      navigate("/admin/admin_reset_password", {
        state: { email, userID},
      });
    } else {
      setMessage("Invalid OTP. Please try again.");
    }
  };

  const handleResendCode = async (e) => {
    e.preventDefault();
    setSentOtp(""); // Clear OTP locally

    console.log(sentOtp);
    console.log(email);

    const data = await getEventController.ResendOTPCode(email);

    console.log(data);

    if (data) {
      setSentOtp(data);
    }
  };

  return (
    <div className="otp-page">
      <div className="d-flex otp-container">
        <div className="otp-wrapper">
          <div className="login-title">
            <img className="web-login-logo" src={logo} alt="Logo" />
          </div>
          <p className="title_para">ACCOUNT VERIFICATION</p>
          <div className="forgot-icon-row">
            <img className="otp-icon" src={OTPicon} alt="OTP" />
          </div>
          <p className="forgot-span">
            Please enter the 6 digit code sent to your registered email.
          </p>
          <form className="otp-form" onSubmit={handleSubmitOTP}>
            <div className="otp-form-row">
              <OTPform value={otp} onChange={setOtp} length={6} />
            </div>
            {message && <p>{message}</p>}
            <h6>*An 6 digit code sent to {email}</h6>
            <div className="resend-button">
              <Button
                sx={{
                  color: "black",
                  textTransform: "none",
                }}
                onClick={handleResendCode}
              >
                Resend Code
              </Button>
            </div>
            <div>
              <Button
                className="verify-button"
                type="submit"
                // onClick={() => navigate("/membership_selection")}
              >
                Verify
              </Button>
            </div>
            <div>
              <Button
                className="verify-button"
                onClick={() => navigate("/admin/login")}
              >
                Return to Login Page
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OTP;
